import angular from 'angular';
// TODO: import stuff that you need below

// Which recipe do I need?
// A custom element that is self contained? - component()
// A custom attribute that modifies behavior? - directive()
// An object to be available to Controllers? - service()
// A service that needs special treatment before or after instantiation? - factory()
// A service that needs injections that are only available after Angular boots? - provider()
// A class, value or function? - use `import ...` not angular's value() or constant()
// Code to run before angular boots? - config()
// Code to run after angular boots? - run()
// Injectable constant value or class that needs to be unit testable? - constant()
import { attViewerPrizmComponent } from './attViewerPrizmComponent';

angular
	.module('sh.attViewerPrizm', [])
	// .config(FunctionWithInjections)                                  // Executes before Angular boots up
	// .run(FunctionWithInjections)                                     // Executes after Angular boots up
	// .component('shElementName', elementNameComponent())              // <sh-element-name>
	// .factory('FunctionThatReturnsSimpleObject', SimpleObjectFactory) // Function receives injections
	// .directive('shAttributeName', attributeNameDirective)            // <div sh-attribute-name"...">
	// .service('RegularClass', RegularClass)                           // Constructor receives injections
	// .provider('ClassWith$getMethod', ClassWith$getMethod)            // $get() receives injections
	// .config(InterceptorInit)                                         // Add an http interceptor
	// .filter('shFilterName', FilterReturningFunction)                 // Register an angular filter
	// .decorator('AngularOr3rdPartyService', FunctionReceivesService)  // Monkey patch other services
	// .constant('name', injectableAndMockableValueFunctionOrObject)    // Available at all times
	.component('shAttViewerPrizm', attViewerPrizmComponent());

/*

@see https://docs.angularjs.org/guide/providers
@see http://tylermcginnis.com/angularjs-factory-vs-service-vs-provider/

Feature     /      Recipe type		Factory   Service   Value   Constant   Provider
can have dependencies				yes       yes       no      no         yes
uses type friendly injection		no        yes       yes*    yes*       no
object available in config phase	no        no        no      yes        yes**
can create functions				yes       yes       yes     yes        yes
can create primitives				yes       no        yes     yes        yes

available to Providers              no?       no?       yes     yes        no?
available to Ctrl constructors      yes       yes       yes     yes        yes
available to Factories              no?       yes       yes     yes        yes

* at the cost of eager initialization by using new operator directly
** the service object is not available during the config phase, but the provider instance is (see the unicornLauncherProvider example above).

*/
